import { GraphQLError, GraphQLErrorExtensions } from 'graphql'

export const isBoolean = (x: unknown): x is boolean => 'boolean' === typeof x

export const isNil = <T>(x: T | null | undefined): x is null | undefined => {
  return x == null
}

export const isNotNil = <T>(x: T | null | undefined): x is T => !isNil(x)

export const isString = (x: unknown): x is string =>
  typeof x === 'string' || x instanceof String

// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (x: unknown): x is Function =>
  // eslint-disable-next-line eqeqeq
  Object.prototype.toString.call(x) == '[object Function]'

/**
 * Shopify passes us an ID like this:
 * gid://shopify/Product/7197695967448
 *
 * This will return 7197695967448
 */
export const getIdFromShopifyGid = (x: string): string => {
  const maybeId = /([^/]+$)/.exec(x)?.[0]

  if (!maybeId) {
    // TODO: can this even throw?
    throw new Error(`Could not find ID from ${x}!`)
  }

  return maybeId
}

export const castUndefinedOrValue = <T>(x: T): NonNullable<T> | undefined => {
  return x === null ? undefined : (x as NonNullable<T>)
}

export const isUuid = (str: string) => {
  const uuidRegExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  return uuidRegExp.test(str)
}

export function gqlError(
  message: string,
  extensions?: GraphQLErrorExtensions | null,
) {
  return new GraphQLError(message, null, null, null, null, null, extensions)
}
